/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetRowSnipsParams,
  HTTPValidationError,
  RowSnipResponse,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getRowSnipsResponse200 = {
  data: RowSnipResponse[];
  status: 200;
};

export type getRowSnipsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getRowSnipsResponseSuccess = getRowSnipsResponse200 & {
  headers: Headers;
};
export type getRowSnipsResponseError = getRowSnipsResponse422 & {
  headers: Headers;
};

export type getRowSnipsResponse =
  getRowSnipsResponseSuccess | getRowSnipsResponseError;

export const getGetRowSnipsUrl = (params?: GetRowSnipsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/snips/row?${stringifiedParams}`
    : `/api/snips/row`;
};

/**
 * ortho_id or trial_id is required.
 * @summary List row snips
 */
export const getRowSnips = async (
  params?: GetRowSnipsParams,
  options?: RequestInit,
): Promise<getRowSnipsResponse> => {
  const res = await fetch(getGetRowSnipsUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRowSnipsResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getRowSnipsResponse;
};

export const getGetRowSnipsQueryKey = (params?: GetRowSnipsParams) => {
  return [`/api/snips/row`, ...(params ? [params] : [])] as const;
};

export const getGetRowSnipsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRowSnips>>,
  TError = HTTPValidationError,
>(
  params?: GetRowSnipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowSnips>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRowSnipsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRowSnips>>> = ({
    signal,
  }) => getRowSnips(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRowSnips>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRowSnipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRowSnips>>
>;
export type GetRowSnipsQueryError = HTTPValidationError;

export function useGetRowSnips<
  TData = Awaited<ReturnType<typeof getRowSnips>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRowSnipsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowSnips>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRowSnips>>,
          TError,
          Awaited<ReturnType<typeof getRowSnips>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRowSnips<
  TData = Awaited<ReturnType<typeof getRowSnips>>,
  TError = HTTPValidationError,
>(
  params?: GetRowSnipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowSnips>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRowSnips>>,
          TError,
          Awaited<ReturnType<typeof getRowSnips>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRowSnips<
  TData = Awaited<ReturnType<typeof getRowSnips>>,
  TError = HTTPValidationError,
>(
  params?: GetRowSnipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowSnips>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List row snips
 */

export function useGetRowSnips<
  TData = Awaited<ReturnType<typeof getRowSnips>>,
  TError = HTTPValidationError,
>(
  params?: GetRowSnipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowSnips>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRowSnipsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
